/**
 * Custom error class for session expiration
 *
 * This error is thrown when the refresh token has expired and the user
 * needs to log in again. It allows components to distinguish between
 * session expiration and other API errors.
 */
export class SessionExpiredError extends Error {
  public readonly isSessionExpired = true;

  constructor(message = 'Session expired') {
    super(message);
    this.name = 'SessionExpiredError';

    // Restore prototype chain for instanceof checks
    Object.setPrototypeOf(this, SessionExpiredError.prototype);
  }
}

/**
 * Type guard to check if an error is a SessionExpiredError
 */
export function isSessionExpiredError(error: unknown): error is SessionExpiredError {
  return error instanceof SessionExpiredError ||
         (error !== null && typeof error === 'object' && 'isSessionExpired' in error);
}
